var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOlympic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 24h30V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081c8",
    d: "M6.59 7.24a2.95 2.95 0 1 0 0 5.9 2.95 2.95 0 0 0 0-5.9M2.4 10.19a4.19 4.19 0 1 1 8.38 0 4.19 4.19 0 0 1-8.38 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.07 7.24a2.95 2.95 0 1 0 0 5.9 2.95 2.95 0 0 0 0-5.9m-4.2 2.95a4.19 4.19 0 1 1 8.39 0 4.19 4.19 0 0 1-8.38 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee334e",
    d: "M23.55 7.24a2.95 2.95 0 1 0 0 5.9 2.95 2.95 0 0 0 0-5.9m-4.2 2.95a4.19 4.19 0 1 1 8.38 0 4.19 4.19 0 0 1-8.37 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb131",
    d: "M10.83 10.86a2.95 2.95 0 1 0 0 5.9 2.95 2.95 0 0 0 0-5.9m-4.2 2.95a4.19 4.19 0 1 1 8.39 0 4.19 4.19 0 0 1-8.38 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    d: "M19.3 10.86a2.95 2.95 0 1 0 0 5.9 2.95 2.95 0 0 0 0-5.9m-4.18 2.95a4.19 4.19 0 1 1 8.37 0 4.19 4.19 0 0 1-8.37 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081c8",
    d: "M9.54 10.19c0-.64-.2-1.26-.6-1.77l1-.74a4.2 4.2 0 0 1 0 5.02l-1-.74c.4-.51.6-1.13.6-1.77"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.02 10.19a3 3 0 0 0-.6-1.77l1-.74a4.2 4.2 0 0 1 0 5.02l-1-.74c.39-.51.6-1.13.6-1.77m-4.72 2.36c.5.38 1.13.59 1.77.59v1.24c-.9 0-1.8-.3-2.52-.84z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee334e",
    d: "M21.78 12.55c.5.38 1.13.59 1.76.59v1.24c-.9 0-1.78-.3-2.5-.84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlympic);
export default __webpack_public_path__ + "static/media/olympic.9a66d6337c2939c5d4bf11fe6060e5de.svg";
export { ForwardRef as ReactComponent };